import { useNavigate } from "react-router-dom";

const chapters = [
  {
    id: "database",
    chapter: "Chapter 01",
    tag: "OEM Parts Intelligence",
    title: "CORE PARTS DATABASE",
    subtitle: "15,000+ verified SKUs across Engine, Suspension, Collision & Maintenance categories. Real domestic distribution data — not marketing claims.",
    cta: "Explore Database",
    href: "/catalog",
    image: "https://public.readdy.ai/ai/img_res/a3c20803dae55edc5e1eefb46daf6101.jpg",
    alt: "OEM auto parts database European engine components suspension wholesale",
    stats: [
      { value: "15,000+", label: "Verified SKUs" },
      { value: "4", label: "Core Categories" },
      { value: "2004–2024", label: "Euro Coverage" },
    ],
    accent: "#F59E0B",
    dark: true,
  },
  {
    id: "lubricants",
    chapter: "Chapter 02",
    tag: "Strategic Commodity",
    title: "GENUINE SHELL LUBRICANTS",
    subtitle: "Direct fulfillment via Hong Kong Channels. Shell Helix Ultra 5W-30, 5W-40, 0W-40, 0W-30, 0W-20 — 100% authentic, batch-traceable. FCL & LCL via Guangzhou & Ningbo.",
    cta: "View Full Oil Specs",
    href: "/lubricants",
    image: "https://readdy.ai/api/search-image?query=professional%20product%20photography%20of%20multiple%20Shell%20Helix%20Ultra%20motor%20oil%20bottles%205W-30%200W-40%20arranged%20on%20clean%20white%20surface%20with%20dramatic%20studio%20lighting%20warm%20amber%20tones%20premium%20automotive%20lubricant%20commercial%20photography%20ultra%20high%20resolution&width=1200&height=700&seq=showroom-lubricants-v1&orientation=landscape",
    alt: "Shell Helix Ultra genuine wholesale lubricant Hong Kong channel FCL LCL",
    stats: [
      { value: "5", label: "Helix Ultra Grades" },
      { value: "HK", label: "Direct Channel" },
      { value: "FCL/LCL", label: "Fulfillment" },
    ],
    accent: "#F59E0B",
    dark: false,
  },
  {
    id: "industrial",
    chapter: "Chapter 03",
    tag: "Industrial Series",
    title: "SHELL INDUSTRIAL OIL SERIES",
    subtitle: "Full Shell industrial range: Tellus Hydraulic, Omala Gear, Corena Compressor, Spirax Transmission, Morlina Bearing, Diala Electrical. Volume B2B export via China-Europe Railway.",
    cta: "B2B Volume Quote",
    href: "/industrial-oils",
    image: "https://readdy.ai/api/search-image?query=dramatic%20industrial%20photograph%20of%20large%20steel%20oil%20drums%20barrels%20in%20a%20massive%20warehouse%20with%20forklift%20heavy%20machinery%20hydraulic%20equipment%20factory%20floor%20warm%20industrial%20lighting%20ultra%20high%20resolution%20commercial%20photography%20professional&width=1200&height=700&seq=showroom-industrial-v1&orientation=landscape",
    alt: "Shell industrial hydraulic oil Tellus Omala Corena wholesale B2B export",
    stats: [
      { value: "6", label: "Industrial Series" },
      { value: "208L", label: "Drum Available" },
      { value: "Rail", label: "China-Europe Express" },
    ],
    accent: "#D97706",
    dark: true,
  },
  {
    id: "foundry",
    chapter: "Chapter 04",
    tag: "OE-Tier Manufacturing",
    title: "OE-TIER CYLINDER FOUNDRY",
    subtitle: "Reverse engineering & mass production of brand new cast-iron and aluminum engine blocks. K4M 1.6 16V B2B best-seller. Custom tooling from OE samples. EAC Certified. White customs.",
    cta: "Inside the Foundry",
    href: "/foundry",
    image: "https://readdy.ai/api/search-image?query=dramatic%20cinematic%20photograph%20of%20molten%20metal%20being%20poured%20in%20industrial%20foundry%20casting%20facility%20with%20bright%20orange%20glowing%20liquid%20metal%20sparks%20flying%20workers%20in%20protective%20gear%20massive%20industrial%20machinery%20dark%20atmospheric%20factory%20ultra%20high%20resolution%20commercial%20photography&width=1200&height=700&seq=showroom-foundry-v1&orientation=landscape",
    alt: "OEM cylinder block foundry China custom engine block tooling cast iron engine block supplier",
    stats: [
      { value: "100%", label: "Brand New" },
      { value: "EAC", label: "Certified" },
      { value: "FCL/LCL", label: "Guangzhou Hub" },
    ],
    accent: "#F59E0B",
    dark: false,
  },
];

export default function ShowroomHub() {
  const navigate = useNavigate();

  return (
    <section id="showroom" className="overflow-hidden">
      {chapters.map((ch, idx) => (
        <div
          key={ch.id}
          className="relative min-h-screen flex items-center overflow-hidden"
          style={{ background: ch.dark ? "#0a0e1a" : "#F4F1EC" }}
        >
          {/* Background image */}
          <div className="absolute inset-0">
            <img
              src={ch.image}
              alt={ch.alt}
              title={ch.alt}
              className="w-full h-full object-cover object-center"
            />
            <div
              className="absolute inset-0"
              style={{
                background: ch.dark
                  ? idx % 2 === 0
                    ? "linear-gradient(to right, rgba(8,12,24,0.97) 0%, rgba(8,12,24,0.85) 55%, rgba(8,12,24,0.5) 100%)"
                    : "linear-gradient(to left, rgba(8,12,24,0.97) 0%, rgba(8,12,24,0.85) 55%, rgba(8,12,24,0.5) 100%)"
                  : idx % 2 === 0
                    ? "linear-gradient(to right, rgba(244,241,236,0.97) 0%, rgba(244,241,236,0.88) 55%, rgba(244,241,236,0.4) 100%)"
                    : "linear-gradient(to left, rgba(244,241,236,0.97) 0%, rgba(244,241,236,0.88) 55%, rgba(244,241,236,0.4) 100%)",
              }}
            />
          </div>

          <div className="relative z-10 w-full max-w-6xl mx-auto px-6 py-24">
            <div
              className={`flex flex-col lg:flex-row items-center gap-16 ${idx % 2 !== 0 ? "lg:flex-row-reverse" : ""}`}
            >
              {/* Text Content */}
              <div className="flex-1 max-w-xl">
                {/* Chapter tag */}
                <div className="flex items-center gap-3 mb-6">
                  <span
                    className="text-xs font-mono tracking-widest"
                    style={{ color: ch.accent, letterSpacing: "0.2em" }}
                  >
                    {ch.chapter}
                  </span>
                  <div className="h-px flex-1 max-w-12" style={{ background: ch.accent, opacity: 0.4 }} />
                </div>

                {/* Category badge */}
                <div
                  className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6"
                  style={{
                    background: "rgba(245,158,11,0.1)",
                    border: "1px solid rgba(245,158,11,0.3)",
                  }}
                >
                  <span
                    className="text-xs tracking-widest uppercase font-medium"
                    style={{ color: ch.accent, letterSpacing: "0.18em" }}
                  >
                    {ch.tag}
                  </span>
                </div>

                {/* Title */}
                <h2
                  className="font-thin leading-none mb-3"
                  style={{
                    fontSize: "clamp(1.8rem, 3.5vw, 3rem)",
                    letterSpacing: "0.04em",
                    color: ch.dark ? "#ffffff" : "#1a2332",
                  }}
                >
                  {ch.title}
                </h2>
                <div className="mb-6" style={{ width: "50px", height: "2px", background: ch.accent }} />

                {/* Subtitle */}
                <p
                  className="text-sm font-light leading-relaxed mb-8"
                  style={{
                    color: ch.dark ? "rgba(255,255,255,0.65)" : "rgba(30,45,65,0.7)",
                    lineHeight: "1.85",
                  }}
                >
                  {ch.subtitle}
                </p>

                {/* Stats row */}
                <div className="flex flex-wrap gap-4 mb-8">
                  {ch.stats.map((stat) => (
                    <div key={stat.label} className="text-center">
                      <p
                        className="text-xl font-bold leading-none mb-1"
                        style={{ color: ch.accent }}
                      >
                        {stat.value}
                      </p>
                      <p
                        className="text-xs font-light"
                        style={{
                          color: ch.dark ? "rgba(255,255,255,0.4)" : "rgba(30,45,65,0.5)",
                          fontSize: "10px",
                          letterSpacing: "0.08em",
                        }}
                      >
                        {stat.label}
                      </p>
                    </div>
                  ))}
                </div>

                {/* CTA */}
                <button
                  onClick={() => navigate(ch.href)}
                  className="flex items-center gap-2 px-7 py-3.5 rounded-xl text-sm font-bold tracking-widest whitespace-nowrap cursor-pointer transition-all duration-200 hover:brightness-110 active:scale-95 text-white"
                  style={{
                    background: "linear-gradient(135deg, #F59E0B 0%, #D97706 100%)",
                    letterSpacing: "0.12em",
                  }}
                >
                  {ch.cta}
                  <i className="ri-arrow-right-line text-sm" />
                </button>
              </div>

              {/* Visual panel — decorative stats card */}
              <div className="flex-1 max-w-sm w-full">
                <div
                  className="rounded-2xl p-8"
                  style={{
                    background: ch.dark ? "rgba(255,255,255,0.05)" : "rgba(255,255,255,0.7)",
                    border: ch.dark ? "1px solid rgba(255,255,255,0.1)" : "1px solid rgba(0,0,0,0.08)",
                    backdropFilter: "blur(12px)",
                  }}
                >
                  <div className="flex items-center gap-3 mb-6">
                    <div
                      className="w-10 h-10 flex items-center justify-center rounded-xl"
                      style={{ background: "rgba(245,158,11,0.15)", border: "1px solid rgba(245,158,11,0.3)" }}
                    >
                      <i
                        className={`text-lg ${
                          ch.id === "database" ? "ri-database-2-line" :
                          ch.id === "lubricants" ? "ri-drop-fill" :
                          ch.id === "industrial" ? "ri-settings-2-line" :
                          "ri-fire-line"
                        }`}
                        style={{ color: ch.accent }}
                      />
                    </div>
                    <div>
                      <p
                        className="text-xs font-bold tracking-widest uppercase"
                        style={{ color: ch.dark ? "rgba(255,255,255,0.8)" : "#1a2332", letterSpacing: "0.12em" }}
                      >
                        {ch.id === "database" ? "OE Database" :
                         ch.id === "lubricants" ? "Shell Lubricants" :
                         ch.id === "industrial" ? "Industrial Oils" :
                         "Foundry Division"}
                      </p>
                      <p className="text-xs font-light mt-0.5" style={{ color: "rgba(245,158,11,0.7)" }}>
                        {ch.tag}
                      </p>
                    </div>
                  </div>

                  <div className="flex flex-col gap-3 mb-6">
                    {ch.stats.map((stat) => (
                      <div
                        key={stat.label}
                        className="flex items-center justify-between px-4 py-3 rounded-xl"
                        style={{
                          background: ch.dark ? "rgba(255,255,255,0.04)" : "rgba(0,0,0,0.04)",
                          border: ch.dark ? "1px solid rgba(255,255,255,0.06)" : "1px solid rgba(0,0,0,0.06)",
                        }}
                      >
                        <span
                          className="text-xs font-light"
                          style={{ color: ch.dark ? "rgba(255,255,255,0.5)" : "rgba(30,45,65,0.55)" }}
                        >
                          {stat.label}
                        </span>
                        <span className="text-sm font-bold" style={{ color: ch.accent }}>
                          {stat.value}
                        </span>
                      </div>
                    ))}
                  </div>

                  <button
                    onClick={() => navigate(ch.href)}
                    className="w-full flex items-center justify-center gap-2 py-3 rounded-xl text-xs font-bold tracking-widest cursor-pointer transition-all duration-200 hover:brightness-110 text-white whitespace-nowrap"
                    style={{
                      background: "linear-gradient(135deg, #F59E0B 0%, #D97706 100%)",
                      letterSpacing: "0.14em",
                    }}
                  >
                    {ch.cta}
                    <i className="ri-external-link-line text-xs" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Chapter number watermark */}
          <div
            className="absolute bottom-8 right-8 font-mono font-bold pointer-events-none select-none"
            style={{
              fontSize: "clamp(4rem, 8vw, 8rem)",
              color: ch.dark ? "rgba(255,255,255,0.03)" : "rgba(0,0,0,0.04)",
              letterSpacing: "-0.05em",
            }}
          >
            {String(idx + 1).padStart(2, "0")}
          </div>
        </div>
      ))}
    </section>
  );
}
